import { render, staticRenderFns } from "./DeleteEmptyHomes.vue?vue&type=template&id=766dfc6b"
import script from "./DeleteEmptyHomes.vue?vue&type=script&lang=ts"
export * from "./DeleteEmptyHomes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports